import { render, staticRenderFns } from "./PackagePaidPatient.vue?vue&type=template&id=3a7e3998"
import script from "./PackagePaidPatient.vue?vue&type=script&lang=js"
export * from "./PackagePaidPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports